export function useGlobalWindowManager() {
  const setGlobalCssVariable = (variableName: string, value: string) => {
    document.documentElement.style.setProperty(variableName, value);
  };

  return {
    setGlobalCssVariable,
  };
}
